import Container from "./container";

export default function SolucoesPerso() {
    return (
        <section className="bg-[url(../assets/bg-wave-vertical.png)] bg-contain md:bg-auto bg-left-bottom lg:bg-[url(../assets/cover-solucoes-perso.png)] lg:bg-cover bg-no-repeat lg:bg-center text-white bg-[#060316] relative overflow-hidden">
            {/* Blur effect */}
            <div className="absolute inset-0 blur-2xl bg-black/90 w-[80%] mx-auto left-0 right-0 mt-16 rounded-full opacity-80" />

            <Container className="lg:max-w-[1240px] pt-7 pb-24 lg:py-32 space-y-12 md:space-y-20 relative z-10">
                <header className="text-center px-2">
                    <h2 className="text-3xl md:text-4xl lg:text-6xl font-inter-regular">
                        <span className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] text-transparent bg-clip-text">
                            Soluções personalizadas
                        </span>{" "}
                        para potencializar a eficiência e ampliar os resultados
                        do seu negócio.
                    </h2>
                </header>
                <main className="flex flex-col lg:flex-row gap-6 py-4 px-14 lg:px-12 backdrop-blur-[50px] rounded-[10px] border border-white bg-[#FFFFFF10]">
                    <div className="text-center flex flex-col items-center py-8">
                        <h3 className="text-2xl font-inter-bold mb-4">
                            Soluções de Alta Qualidade:
                        </h3>
                        <p className="text-white text-base max-w-xs">
                            Arquiteturas robustas e escaláveis que suportam o
                            crescimento e a evolução do negócio.
                        </p>
                    </div>

                    <div className="w-full h-px lg:h-36 lg:w-px bg-[#C4C4C4] m-auto" />

                    <div className="text-center flex flex-col items-center py-8">
                        <h3 className="text-2xl font-inter-bold mb-4">
                            Melhoria de Qualidade:
                        </h3>
                        <p className="text-white text-base max-w-xs">
                            Aumento significativo no desempenho e eficiência
                            operacional.
                        </p>
                    </div>

                    <div className="w-full h-px lg:h-36 lg:w-px bg-[#C4C4C4] m-auto" />

                    <div className="text-center flex flex-col items-center py-8">
                        <h3 className="text-2xl font-inter-bold mb-4">
                            Segurança Fortalecida:
                        </h3>
                        <p className="text-white text-base max-w-xs">
                            Soluções seguras que protegem dados sensíveis e
                            garantem a continuidade dos negócios.
                        </p>
                    </div>

                    <div className="w-full h-px lg:h-36 lg:w-px bg-[#C4C4C4] m-auto" />

                    <div className="text-center flex flex-col items-center py-8">
                        <h3 className="text-2xl font-inter-bold mb-4">
                            Alinhamento Estratégico:
                        </h3>
                        <p className="text-white text-base max-w-xs">
                            Soluções que estão alinhadas com os objetivos
                            estratégicos de negócios, proporcionando vantagem
                            competitiva.
                        </p>
                    </div>
                </main>
            </Container>
        </section>
    );
}
